export default "__VITE_ASSET__EGre3KNbaaAfihEAhTGFNQ__"